import * as z from "zod";
import { blockCodePartSchema } from "./block-content";

export const BLOCK_SERVICE_PROTOCOL = 1;

export const blockServiceReadyMessageSchema = z.object({
  type: z.literal("redo:ready"),
  v: z.literal(BLOCK_SERVICE_PROTOCOL),
  frameId: z.string().min(1),
});
export type BlockServiceReadyMessage = z.infer<
  typeof blockServiceReadyMessageSchema
>;

/** The host's typography, passed through to the frame's document. */
export const blockServiceThemeSchema = z.object({
  lang: z.string().optional(),
  cssVars: z.record(z.string(), z.string()).optional(),
  fontFaces: z.string().optional(),
});
export type BlockServiceTheme = z.infer<typeof blockServiceThemeSchema>;

export const blockServiceRenderMessageSchema = z.object({
  type: z.literal("redo:render"),
  v: z.literal(BLOCK_SERVICE_PROTOCOL),
  frameId: z.string().min(1),
  blockId: z.string().min(1),
  html: z.string(),
  code: z.array(blockCodePartSchema),
  theme: blockServiceThemeSchema.optional(),
  context: z.unknown(),
  page: z.unknown(),
});
export type BlockServiceRenderMessage = z.infer<
  typeof blockServiceRenderMessageSchema
>;

export const blockServiceHeightMessageSchema = z.object({
  type: z.literal("redo:frame-height"),
  frameId: z.string().min(1),
  height: z.number(),
});
export type BlockServiceHeightMessage = z.infer<
  typeof blockServiceHeightMessageSchema
>;

export const blockServiceContextMessageSchema = z.object({
  type: z.literal("redo:context"),
  frameId: z.string().min(1),
  context: z.unknown(),
});
export type BlockServiceContextMessage = z.infer<
  typeof blockServiceContextMessageSchema
>;

export const blockServiceErrorKindSchema = z.enum([
  "liquid",
  "script-error",
  "script-timeout",
  "boot",
]);
export type BlockServiceErrorKind = z.infer<typeof blockServiceErrorKindSchema>;

export const blockServiceErrorMessageSchema = z.object({
  type: z.literal("redo:error"),
  frameId: z.string().min(1),
  kind: blockServiceErrorKindSchema,
  message: z.string().optional(),
  url: z.string().optional(),
});
export type BlockServiceErrorMessage = z.infer<
  typeof blockServiceErrorMessageSchema
>;

export const blockServiceIncomingMessageSchema = z.discriminatedUnion("type", [
  blockServiceRenderMessageSchema,
  blockServiceContextMessageSchema,
]);
export type BlockServiceIncomingMessage = z.infer<
  typeof blockServiceIncomingMessageSchema
>;

export const blockServiceOutgoingMessageSchema = z.discriminatedUnion("type", [
  blockServiceReadyMessageSchema,
  blockServiceHeightMessageSchema,
  blockServiceErrorMessageSchema,
]);
export type BlockServiceOutgoingMessage = z.infer<
  typeof blockServiceOutgoingMessageSchema
>;

export function parseIncomingBlockServiceMessage(
  value: unknown,
): BlockServiceIncomingMessage | null {
  const parsed = blockServiceIncomingMessageSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}

export function parseOutgoingBlockServiceMessage(
  value: unknown,
): BlockServiceOutgoingMessage | null {
  const parsed = blockServiceOutgoingMessageSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}
